/**
 * Foto de la prueba (roturas y productos con detalles): la del teléfono pesa varios MB, así que se reduce aquí a un
 * JPEG de hasta 1280 px por lado (unos 100 a 300 KB) antes de enviarla. La API acepta hasta 750 KB.
 */
export async function reducirFoto(archivo: File, lado = 1280, calidad = 0.75): Promise<string> {
  const url = URL.createObjectURL(archivo);
  try {
    const img = await new Promise<HTMLImageElement>((resolver, rechazar) => {
      const i = new Image();
      i.addEventListener('load', () => resolver(i), { once: true });
      i.addEventListener('error', () => rechazar(new Error('No se pudo leer la imagen: elige una foto JPG o PNG')), { once: true });
      i.src = url;
    });
    const escala = Math.min(1, lado / Math.max(img.naturalWidth, img.naturalHeight));
    const lienzo = document.createElement('canvas');
    lienzo.width = Math.max(1, Math.round(img.naturalWidth * escala));
    lienzo.height = Math.max(1, Math.round(img.naturalHeight * escala));
    const ctx = lienzo.getContext('2d');
    if (!ctx) throw new Error('Este navegador no puede preparar la foto');
    ctx.drawImage(img, 0, 0, lienzo.width, lienzo.height);
    const dato = lienzo.toDataURL('image/jpeg', calidad);
    // Una foto con mucho detalle puede seguir pesando: se reduce una vez más
    if (dato.length > 900_000 && lado > 800) return await reducirFoto(archivo, 800, 0.6);
    return dato;
  } finally {
    URL.revokeObjectURL(url);
  }
}
